import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/core/services/base.service';
import { SharedModel } from 'src/app/main/consultor/models/shared.model';
import { PageModel } from 'src/app/core/models/page.model';


@Injectable({
  providedIn: 'root'
})
export class SharedService extends BaseService {
  private baseUrl = '/shared';

  add(body: any): Observable<SharedModel[]> {
    return this.basePost(`${this.baseUrl}/add/`, body);
  }

  remove(cardId: number): Observable<SharedModel[]> {
    const params = new HttpParams().append('cardId', String(cardId));
    return this.baseGetWithParams(`${this.baseUrl}/remove`, params);
  }

  getHaoFromShared(page: any, size: any): Observable<PageModel<SharedModel>> {
    const params = new HttpParams()
        .append('page', page)
        .append('size', size)
    ;
    return this.baseGetWithParams<PageModel<SharedModel>>(`${this.baseUrl}/all-shared`, params);
  }

}
